import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const LOAD_CUSTOMER = 'LOAD_CUSTOMER';
export const LOAD_CUSTOMER_DATA = 'LOAD_CUSTOMER_DATA';
export const LOAD_CUSTOMER_DATA_FAILURE = 'LOAD_CUSTOMER_DATA_FAILURE';
export const LINK_CUSTOMER_ACCOUNT = 'LINK_CUSTOMER_ACCOUNT';
export const UNLINK_CUSTOMER_ACCOUNT = 'UNLINK_CUSTOMER_ACCOUNT';
export const UNLINK_CUSTOMER_FORM = 'UNLINK_CUSTOMER_FORM';
export const OPEN_CUSTOMERID_CHANGE_FORM_MODAL = 'OPEN_CUSTOMERID_CHANGE_FORM_MODAL';
export const CLOSE_CUSTOMERID_CHANGE_FORM_MODAL = 'CLOSE_CUSTOMERID_CHANGE_FORM_MODAL';
export const CHANGECUSTOMERID_REQUEST = 'CHANGECUSTOMERID_REQUEST';
export const CLOSE_CUSTOMERID_CHANGE_FORM_ERROR = 'CLOSE_CUSTOMERID_CHANGE_FORM_ERROR';
export const CLEAR_CHANGECUSTOMERID_REQUEST = 'CLEAR_CHANGECUSTOMERID_REQUEST';
export const CLEAR_CUSTOMER_REQUEST = 'CLEAR_CUSTOMER_REQUEST';

function requestLoadCustomer(customer) {
  return {
    type: LOAD_CUSTOMER,
    storeCustomer: customer
  };
}

function requestLoadCustomerData() {
  return {
    type: LOAD_CUSTOMER_DATA,
  };
}

function requestLinkCustomerAccount() {
  return {
    type: LINK_CUSTOMER_ACCOUNT,
  };
}

function requestUnlinkCustomerAccount() {
  return {
    type: UNLINK_CUSTOMER_ACCOUNT,
  };
}

function requestUnlinkCustomerForm() {
  return {
    type: UNLINK_CUSTOMER_FORM,
  };
}

function openCustomerIdChangeModal() {
  return {
    type: OPEN_CUSTOMERID_CHANGE_FORM_MODAL,
    isCustomerIdChangeModalShown: true
  };
}

function closeCustomerIdChangeModal(id) {
  if (id === true || id === false) {
    return {
      type: CLOSE_CUSTOMERID_CHANGE_FORM_MODAL,
      isCustomerIdChangeModalShown: false
    };
  }
  return {
    type: CLOSE_CUSTOMERID_CHANGE_FORM_MODAL,
    isCustomerIdChangeModalShown: false,
    returnedExistingCustomerId: id
  };
}

function requestCustomerIdChange() {
  return {
    type: CHANGECUSTOMERID_REQUEST
  };
}

function closeCustomerIdChangeFormError() {
  return {
    type: CLOSE_CUSTOMERID_CHANGE_FORM_ERROR,
    isCustomerIdChangeModalShown: true
  };
}

export function clearCompletedCustomerIdChange() {
  return {
    type: CLEAR_CHANGECUSTOMERID_REQUEST
  };
}

export function clearCustomer() {
  return {
    type: CLEAR_CUSTOMER_REQUEST
  };
}

function rejectCustomerDataLoad(customerDataLoadError) {
  return {
    type: LOAD_CUSTOMER_DATA_FAILURE,
    customerDataLoadError
  };
}

export function customerDataLoad(clientId) {
  return (dispatch) => {
    dispatch(requestLoadCustomerData());

    const promise = () => ApiService
      .getCustomerData(clientId)
      .then((response) => {
        dispatch(requestLoadCustomer(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectCustomerDataLoad));
        }
      });
    return promise();
  };
}

export function clearCustomerData() {
  return dispatch => dispatch(clearCustomer());
}

export function customerAccountLink(customerId, addedAccountData) {
  return (dispatch) => {
    dispatch(requestLinkCustomerAccount());

    const customerAccount = {
      CustomerId: customerId,
      Capacity: addedAccountData.capacity,
      ValidFrom: addedAccountData.validFrom,
      ValidUntil: addedAccountData.validUntil,
      Account: {
        id: addedAccountData.accountNumber ? addedAccountData.accountNumber.id : 0,
        accountNumber: addedAccountData.accountNumber ? addedAccountData.accountNumber.value : ''
      }
    };

    const customerAccounts = [customerAccount];
    const promise = () => ApiService
      .linkCustomerAccount(customerId, customerAccounts)
      .then((response) => {
        dispatch(customerDataLoad(customerId));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, true, true));
        }
      });
    return promise();
  };
}

export function customerAccountUnlink(customerId, accountId) {
  const customerAccounts = [accountId];

  return (dispatch) => {
    dispatch(requestUnlinkCustomerAccount());

    console.log('Unlink');

    const promise = () => ApiService
      .unLinkCustomerAccount(customerId, customerAccounts)
      .then((response) => {
        dispatch(customerDataLoad(customerId));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, true));
        }
      });
    return promise();
  };
}

export function customerFormUnlink(customerId, formId) {
  const formIds = [formId];

  return (dispatch) => {
    dispatch(requestUnlinkCustomerForm());

    return ApiService
      .unLinkCustomerForm(customerId, formIds)
      .then((response) => {
        dispatch(customerDataLoad(customerId));
      })
      .catch((error) => {
        dispatch(handleException(error, true));
      });
  };
}

export function hideCustomerIdChangeFormError() {
  return (dispatch) => {
    dispatch(closeCustomerIdChangeFormError());
  };
}

export function showCustomerIdChangeModal() {
  return (dispatch) => {
    dispatch(openCustomerIdChangeModal());
  };
}

export function hideCustomerIdChangeModal(id) {
  return (dispatch) => {
    dispatch(closeCustomerIdChangeModal(id));
  };
}

export function processCustomerIdChange(data) {
  const formData = new FormData();
  formData.append('newCustomerId', data.newId);
  formData.append('transferCustomer', data.transferCustomer);

  return (dispatch) => {
    dispatch(requestCustomerIdChange());

    const promise = () => ApiService
      .updateCustomerId(data.id, formData)
      .then((response) => {
        dispatch(hideCustomerIdChangeModal(response.data));
        if (response.data === true || response.data === false) {
          dispatch(customerDataLoad(data.id));
        }
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, null, true));
        }
      });
    return promise();
  };
}
